/** Textos do painel de filtro de lojas (centralizados para i18n/manutenção). */
export const STORE_FILTER_TEXT = {
  triggerLabel: "Loja",
  title: "Filtrar por loja",
  clear: "Limpar",
  searchPlaceholder: "Buscar por nome ou código...",
  loading: "Carregando...",
  empty: "Nenhuma loja encontrada",
  selectAll: "Selecionar todas",
  unselectAll: "Desmarcar todas",
  cancel: "Cancelar",
  apply: "Aplicar",
  storesUnit: "loja(s)",
} as const;

/** Rótulos das dimensões de filtro (chips). */
export const STORE_FILTER_DIMENSION_LABELS = {
  estado: "Estado",
  regional: "Regional",
} as const;
